<template>
  <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9781 5.88397L9.25313 10.609C8.83125 11.0308 8.1 10.7355 8.1 10.1308V7.43085H4.275C3.90094 7.43085 3.6 7.12991 3.6 6.75585V4.05585C3.6 3.68179 3.90094 3.38085 4.275 3.38085H8.1V0.680847C8.1 0.0789722 8.82844 -0.219153 9.25313 0.202722L13.9781 4.92772C14.2397 5.1921 14.2397 5.6196 13.9781 5.88397ZM5.4 10.4683V9.34335C5.4 9.15772 5.24813 9.00585 5.0625 9.00585H2.7C2.20219 9.00585 1.8 8.60366 1.8 8.10585V2.70585C1.8 2.20803 2.20219 1.80585 2.7 1.80585H5.0625C5.24813 1.80585 5.4 1.65397 5.4 1.46835V0.343347C5.4 0.157722 5.24813 0.0058472 5.0625 0.0058472H2.7C1.20938 0.0058472 0 1.21522 0 2.70585V8.10585C0 9.59647 1.20938 10.8058 2.7 10.8058H5.0625C5.24813 10.8058 5.4 10.654 5.4 10.4683Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>